/**
 * @generated SignedSource<<7ccab6ec4a2deee299f092f492bdaade>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type DepartmentType = "AQUATICS" | "AXE_THROWING" | "BASKETBALL" | "BOATING" | "BOCCE_BALL" | "BUSINESS" | "CARD_ROOM" | "CLUB" | "CROQUET" | "DINING" | "FITNESS" | "GOLF" | "HOCKEY" | "RACQUET" | "SALON" | "SHUFFLEBOARD" | "SPA";
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
import { FragmentRefs } from "relay-runtime";
export type facilityToScheduleOption_facility$data = {
  readonly department: {
    readonly type: DepartmentType;
  } | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly type: FacilityType;
  readonly " $fragmentType": "facilityToScheduleOption_facility";
};
export type facilityToScheduleOption_facility$key = {
  readonly " $data"?: facilityToScheduleOption_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"facilityToScheduleOption_facility">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "facilityToScheduleOption_facility"
};

(node as any).hash = "cd3d88edfbb856972a697e50088ddc56";

export default node;
